import Slider from './Slider';

export default Slider;
export { Slider };
export type { SliderProps } from './types';
